import type { CheckCookieResponse } from './responses';
import type { Cookies } from '../models';
import { ApiSuccessResponse } from '@/shared/types/api.types';

export function mapResponse(apiResponse: CheckCookieResponse): ApiSuccessResponse<Cookies> {
    return new ApiSuccessResponse({
        id: apiResponse.cx_id,
        base: apiResponse.base,
        redirect: apiResponse.ref,
        environment: apiResponse.environment,
        errrorMessage: apiResponse.err_msg,
    });
}
